import { Button, Grid, Typography } from "@mui/material";
import { Formik } from "formik";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import FormikCheckbox from "../../../commons/formik/FormikCheckbox";
import CircularLoading from "../../../commons/loading/CircularLoading";
import PuestosFormContainer from "../../../commons/puestos/PuestosFormContainer";
import ResponsablesCard from "../../../commons/responsables/responsablesCard/ResponsablesCard";
import SectorFormContainer from "../../../commons/sectores/SectorFormContainer";
import ResponsablesEnum from "../../../enums/responsablesEnum";
import { StyledResolucion } from "../../../styled/Prevencion";
import { cabeceraValidation } from "../validation/formValidation";
import ContratistasYEmpresasContainer from "./formulario/contratistas/ContratistasYEmpresasContainer";
import ResponsablesCards from "./formulario/ResponsablesCards";
import TrabajadoresPaper from "./formulario/TrabajadoresPaper";
import { calcularTotalTrabajadores } from "./utilsCabecera";

const CabeceraForm = ({
  handleSubmit,
  handleCancelForm,
  handleOpenDialog,
  handleEditResponsable,
  formModel,
  isValidating,
}) => {

  const idDependenciaEmpleador = useSelector(
    (state) => state.resolucion.searchedEstablecimiento
  );

  return (
    <>
      {formModel ? (
        <Formik
          initialValues={formModel}
          onSubmit={(values) => {
            let totalTrabajadores = calcularTotalTrabajadores(values);
            if (totalTrabajadores > 0) {
              handleSubmit(values);
            } else {
              toast.error(
                "Es necesario cargar al menos un trabajador para poder avanzar al siguiente paso."
              );
            }
          }}
          validationSchema={cabeceraValidation}
          enableReinitialize={true}
        >
          {({ values, errors }) => (
            <StyledResolucion.Form>
              <Grid container sx={{ mt: 2 }} spacing={2} alignItems="center">
                <Grid item xs={12} md={6}>
                  <TrabajadoresPaper />
                </Grid>
                <Grid item xs={12} md={6}>
                  <ResponsablesCard
                    variant="vertical"
                    name="contacto"
                    responsableType={ResponsablesEnum.contactoEmpresa}
                    title="Contacto"
                    handleOpenAddResponsable={handleOpenDialog}
                    handleEditResponsable={handleEditResponsable}
                    required
                  />
                </Grid>
              </Grid>
              <StyledResolucion.FumarEstablecimiento>
                <FormikCheckbox
                  name="sePuedeFumar"
                  label="Se puede fumar en el Establecimiento"
                />
                <FormikCheckbox
                  name="espacioParaFumar"
                  label="Posee espacio para Fumar"
                />
              </StyledResolucion.FumarEstablecimiento>
              <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                Consulta y Registro de Puestos y Sectores existentes en el Establecimiento
              </Typography>
              <Grid container >
                <Grid item xs={12} md={6} sx={{ pr: { md: 1 } }} >
                  <PuestosFormContainer idDependenciaEmpleador={idDependenciaEmpleador} add />
                </Grid>
                <Grid item xs={12} md={6} >
                  <SectorFormContainer
                    idDependenciaEmpleador={idDependenciaEmpleador}
                    add
                    showDescription={false}
                  />
                </Grid>
              </Grid>
              <ResponsablesCards 
                handleOpenDialog={handleOpenDialog}
                handleEditResponsable={handleEditResponsable}
              />
              <ContratistasYEmpresasContainer
              />

              <StyledResolucion.ButtonContainer>
                <StyledResolucion.CancelButton
                  variant="contained"
                  onClick={handleCancelForm}
                >
                  CANCELAR FORMULARIO
                </StyledResolucion.CancelButton>
                <Button color="primary" type="submit" variant="contained" disabled={isValidating}>
                  {isValidating ? "VALIDANDO..." : "SIGUIENTE"}
                </Button>
              </StyledResolucion.ButtonContainer>
            </StyledResolucion.Form>
          )}
        </Formik >
      ) : (
        <>
          <CircularLoading />
        </>
      )}
    </>
  );
};

export default CabeceraForm;
